export default "__VITE_ASSET__f136b2cf__"